import { useEffect } from 'react';
import { useAuth } from 'oidc-react';
import {
  setShowLoaderStatus,
  setCurrentuserLoggedInStatus
} from '../../redux-building-blocks/actions';
import {useDispatch} from 'react-redux';
import { constants } from '../../constants';
export const SignOut = (props) => {
  const dispatch = useDispatch();
  const auth = useAuth();

  useEffect(() => {
    dispatch(setShowLoaderStatus(true));
  
    const signOut = () => {
      const { prod, uat, otherEnv } = constants.logout_urls;
      auth.userManager.removeUser();
      auth.signOut();
      dispatch(setCurrentuserLoggedInStatus(false));
      dispatch(setShowLoaderStatus(false));
  
      let url = '';
      if (process.env.REACT_APP_ENV === 'prod') {
        url = prod;
      } else if (process.env.REACT_APP_ENV === 'uat') {
        url = uat;
      } else {
        url = otherEnv;
      }
  
      localStorage.clear();
      window.location.href = url;
    };
  
    const timer = setTimeout(signOut, 1000);
    return () => clearTimeout(timer);
  }, [auth, dispatch]); // ✅ warning resolved
}  
